/**
 * @generated SignedSource<<7ffed07f0f3795cd07c10787d4e78d01>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type combinedInviterNotif_personalSettingsDigestNotifications_CombinedInviterNotification_inProductFragment$data = {
  readonly projectInviterNotification: {
    readonly id: string;
    readonly inProductChannel: {
      readonly isEnabled: boolean | null | undefined;
    } | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "combinedInviterNotif_personalSettingsDigestNotifications_CombinedInviterNotification_inProductFragment";
};
export type combinedInviterNotif_personalSettingsDigestNotifications_CombinedInviterNotification_inProductFragment$key = {
  readonly " $data"?: combinedInviterNotif_personalSettingsDigestNotifications_CombinedInviterNotification_inProductFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"combinedInviterNotif_personalSettingsDigestNotifications_CombinedInviterNotification_inProductFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "combinedInviterNotif_personalSettingsDigestNotifications_CombinedInviterNotification_inProductFragment",
  "selections": [
    {
      "concreteType": "JiraNotificationPreference",
      "kind": "LinkedField",
      "name": "projectInviterNotification",
      "plural": false,
      "selections": [
        {
          "kind": "RequiredField",
          "field": {
            "kind": "ScalarField",
            "name": "id"
          },
          "action": "THROW",
          "path": "projectInviterNotification.id"
        },
        {
          "concreteType": "JiraNotificationChannel",
          "kind": "LinkedField",
          "name": "inProductChannel",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "isEnabled"
            }
          ]
        }
      ]
    }
  ],
  "type": "JiraNotificationPreferences"
};

(node as any).hash = "d0f53f2e399bb8ace91f23d5e94a1399";

export default node;
